export default [
    {
        path: '/proposal/:id/presentation',
        props: true,
        component: () => import('@/views/Proposal/Presentation/index'),
    },
    {
        path: '/proposal/:id/presentation/:version',
        props: true,
        component: () => import('@/views/Proposal/Presentation/index'),
    },
    {
        path: '/proposal/:id',
        props: true,
        component: () => import('@/views/Proposal/Show.vue'),
        children: [
            {
                path: '/',
                redirect: {
                    path: 'reissegmenten'
                },
                props: true,
            },
            {
                name: 'lines',
                path: 'reissegmenten',
                component: () => import('@/views/Proposal/Subviews/Lines.vue'),
                props: true,
            },
            {
                name: 'optionals',
                path: 'optioneel',
                component: () => import('@/views/Proposal/Subviews/Optionals.vue'),
                props: true,
            },
            {
                name: 'iata',
                path: 'iata',
                component: () => import('@/views/Proposal/Subviews/Iata.vue'),
                props: true,

            },
            {
                name: 'proposal.financial',
                path: 'financieel',
                component: () => import('@/views/Proposal/Subviews/Financial.vue'),
                props: true,

            },
            {
                name: 'proposal.purchase',
                path: 'inkoop',
                component: () => import('@/views/Proposal/Subviews/Purchase.vue'),
                props: true,

            },
            {
                name: 'proposal.Communication',
                path: 'communicatie',
                component: () => import('@/views/Proposal/Subviews/Communication.vue'),
                props: true,

            },
            {
                name: 'proposal.statusHistory',
                path: 'status-verleden',
                component: () => import('@/views/Proposal/Subviews/StatusHistory.vue'),
                props: true,

            },
            {
                name: 'proposal.Downloads',
                path: 'downloads',
                component: () => import('@/views/Proposal/Subviews/Downloads.vue'),
                props: true,
            },
        ]
    },
    {
        path: '/proposals/offers/general',
        props: true,
        component: () => import('@/views/Proposal/offers'),
    },
    {
        path: '/proposals/offers/margin-check',
        props: true,
        component: () => import('@/views/Proposal/MarginCheckOffers'),
    },
    {
        path: '/proposals/offers/order-check',
        props: true,
        component: () => import('@/views/Proposal/OrderCheckOffers'),
    },
    {
        path: '/proposals/offers/iata-check',
        props: true,
        component: () => import('@/views/Proposal/IataCheckOffers'),
    },
    {
        path: '/proposals/offers/finish-check',
        props: true,
        component: () => import('@/views/Proposal/FinishCheckOffers'),
    },
    {
        path: '/proposals/offers/refused',
        props: true,
        component: () => import('@/views/Proposal/RefusedOffers'),
    },
    {
        path: '/proposals/offers/not-requested',
        props: true,
        component: () => import('@/views/Proposal/NotRequestedOffers'),
    },
    {
        path: '/proposals/offers/requested',
        props: true,
        component: () => import('@/views/Proposal/RequestedOffers'),
    },
    {
        path: '/proposals/offers/to-accepted',
        props: true,
        component: () => import('@/views/Proposal/ToAcceptedOffers'),
    },
    {
        path: '/proposals/offers/cancelled',
        props: true,
        component: () => import('@/views/Proposal/CancelledOffers'),
    },
    {
        path: '/proposals/bookings/general',
        props: true,
        component: () => import('@/views/Proposal/Bookings'),
    },
    {
        path: '/proposals/bookings/cancelled',
        props: true,
        component: () => import('@/views/Proposal/CancelledBookings'),
    },
    {
        path: '/proposals/bookings/list',
        props: true,
        component: () => import('@/views/Proposal/BookingsList'),
    },
    {
        path: '/proposals/bookings/travel-documents',
        props: true,
        component: () => import('@/views/Proposal/TravelDocuments'),
    },
    {
        path: '/proposals/open-payments',
        props: true,
        component: () => import('@/views/Proposal/OpenPayments'),
    },
    {
        path: '/proposals/bookings/departures',
        props: true,
        component: () => import('@/views/Proposal/DepartureBookings'),
    },
];
